<template>
  <div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.companyName"
                    label="Company Name"
                    placeholder="Company Name"
                    :validation="val.form.companyName" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.contactFirstName"
                    label="Contact First Name"
                    placeholder="Contact Last Name"
                    :validation="val.form.contactFirstName" />
      </div>
      <div class="col">
        <base-input v-model="form.contactLastName"
                    label="Contact Last Name"
                    placeholder="Contact Last Name"
                    :validation="val.form.contactLastName" />
      </div>
      <div class="col">
        <base-input v-model="form.contactPhone"
                    label="Contact Phone"
                    type="tel"
                    mask="(###)-###-####"
                    placeholder="(xxx)-xxx-xxxx"
                    :validation="val.form.contactPhone"/>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-6">
        <base-input v-model="form.contactEmail"
                    label="Contact Email"
                    placeholder="Contact Email"
                    :validation="val.form.contactEmail" />
      </div>
      <div class="col-6">
        <base-input v-model="form.confirmEmail"
                    label="Confirm Contact Email"
                    placeholder="Confirm Contact Email"
                    :validation="val.form.confirmEmail" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.address1"
                    label="Contact Address"
                    placeholder="Contact Address"
                    :validation="val.form.address1" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.address2"
                    label="Contact Address 2"
                    placeholder="Contact Address 2"
                    :validation="val.form.address2" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.city"
                    label="Contact City"
                    placeholder="Contact City"
                    :validation="val.form.city" />
      </div>
      <div class="col">
        <base-select v-model="form.state"
                     label="Contact State"
                     :options="formFieldData.states"
                     placeholder=" Contact State"
                     :validation="val.form.state" />
      </div>
      <div class="col">
        <base-input v-model="form.zip"
                    label="Zip Code"
                    placeholder="Contact Zip Code"
                    :validation="val.form.zip"
                    mask="#####" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.burnAddress1"
                    label="Burn Site Address"
                    placeholder="Burn Site Address"
                    :validation="val.form.burnAddress1" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.burnAddress2"
                    label="Burn Site Address 2"
                    placeholder="Burn Site Address 2"
                    :validation="val.form.burnAddress2" />
      </div>`
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.burnCity"
                    label="Burn Site City"
                    placeholder="Burn Site City"
                    :validation="val.form.burnCity" />
      </div>
      <div class="col">
        <base-select v-model="form.burnState"
                     label="Burn Site State"
                     :options="formFieldData.states"
                     placeholder="Burn Site State"
                     :validation="val.form.burnState" />
      </div>
      <div class="col">
        <base-input v-model="form.burnZip"
                    label="Burn Site Zip Code"
                    placeholder="Burn Site Zip Code"
                    :validation="val.form.burnZip"
                    mask="#####" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-6">
        <base-date-picker v-model="form.dateOfBurn"
                          label="Date of Burn"
                          :validation="val.form.dateOfBurn"/>
      </div>
      <div class="col-3">
        <base-time-picker v-model="form.burnStartTime"
                          label="Start Time"
                          default-am-pm="AM"
                          :validation="val.form.burnStartTime"/>
      </div>
      <div class="col-3">
        <base-time-picker v-model="form.burnEndTime"
                          label="End Time"
                          default-am-pm="AM"
                          :validation="val.form.burnEndTime"/>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-6">
        <base-input v-model="form.nameOfForestPreserve"
                    label="Name of Forest Preserve (if applicable)"
                    placeholder="Name of Forest Preserve"
                    :validation="val.form.nameOfForestPreserve" />
      </div>
      <div class="col-6">
        <base-input v-model="form.localFireDepartment"
                    label="Local Fire Department"
                    placeholder="Local Fire Department"
                    :validation="val.form.localFireDepartment" />
      </div>
    </div>
    <bottom-navigation link="recsignature"> Signature </bottom-navigation>
  </div>
</template>

<script>
  import YesNo from '~/components/YesNo'
  import BaseInput from '~/components/BaseInput'
  import BaseCheckbox from '~/components/BaseCheckbox'
  import BaseSelect from '~/components/BaseSelect'
  import BaseFileUploader from '~/components/BaseFileUploader'
  import BottomNavigation from '~/components/BottomNavigation'
  import BaseTimePicker from '~/components/BaseTimePicker'
  import { OpenBurnFormData } from '../../../js/FormObjects';
  import BaseDatePicker from '~/components/BaseDatePicker'

  export default {
    name: 'RecApplicationInforamation',
    props: ['form', 'val'],
    components: { YesNo, BaseInput, BaseCheckbox, BaseFileUploader, BaseSelect, BaseDatePicker, BottomNavigation, BaseTimePicker },
    data() {
      return {
        registerUrl: '',
        loginUrl: '',
        formFieldData: new OpenBurnFormData()
      }
    },
    mounted() {
    },
    methods: {

    }
  }

</script>
